// extracted by mini-css-extract-plugin
export default {"About":"About_About__ZbA+Q","pageUp_btn":"About_pageUp_btn__cJX2b","movebtn":"About_movebtn__KBfXO"};